export const Selectors = {
	Modal: 'ui-kit-modal',
	Header: 'ui-kit-header',
	Body: 'ui-kit-body',
	Footer: 'ui-kit-footer',
	Title: 'ui-kit-title',
	CloseButton: 'ui-kit-close-button',
};
